// extracted by mini-css-extract-plugin
module.exports = {"root":"AssignSquads_root__2Tr5a","tableControls":"AssignSquads_tableControls__3jWjX","search":"AssignSquads_search__2gud5"};